/**
 * Auth0 のコールバックパラメータ(code/state/error)の有無を判定する。
 * auth0-react の utils 実装を流用。
 * @see https://github.com/auth0/auth0-react/blob/main/src/utils.tsx
 */
const CODE_RE = /[?&]code=[^&]+/;
const STATE_RE = /[?&]state=[^&]+/;
const ERROR_RE = /[?&]error=[^&]+/;

export const hasAuthParams = (searchParams = window.location.search): boolean =>
  (CODE_RE.test(searchParams) || ERROR_RE.test(searchParams)) && STATE_RE.test(searchParams);
